
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class DataVisualsGrid extends Serenity.EntityGrid<DataVisualsRow, any> {
        protected getColumnsKey() { return 'Data.DataVisuals'; }
        protected getDialogType() { return DataVisualsDialog; }
        protected getIdProperty() { return DataVisualsRow.idProperty; }
        protected getLocalTextPrefix() { return DataVisualsRow.localTextPrefix; }
        protected getService() { return DataVisualsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}